/**
 * The `?sp=` of the BI explorer: the form as base64 of its UTF-8 JSON (CU-869fmhmx8 D9). Shared by BI (copy and
 * save a link, open with filters) and the BI dashboards (open in Advanced (BI)). Same output as BI's encoder
 * before it moved here, so the links saved before keep opening.
 *
 * No imports: `node --test` runs it.
 */

export function encodeSp(obj) {
	const bytes = new TextEncoder().encode(JSON.stringify(obj))
	let binary = ''
	for (const b of bytes) binary += String.fromCharCode(b)
	return btoa(binary)
}

/** `encodeSp` ready for a query string: `+`, `/` and `=` escaped, so `searchParams.get('sp')` gives it back intact */
export function encodeSpParam(obj) {
	return encodeURIComponent(encodeSp(obj))
}

/** The decoded object, or `null` when the value is not a valid `sp`. Tolerates the spaces of old, unencoded links. */
export function decodeSp(sp) {
	if (!sp) return null
	try {
		// base64 never has spaces: a space is a `+` of a link saved before the links were URL-encoded
		const bytes = Uint8Array.from(atob(String(sp).replace(/ /g, '+')), c => c.charCodeAt(0))
		const decoded = JSON.parse(new TextDecoder().decode(bytes))
		return decoded && typeof decoded === 'object' && !Array.isArray(decoded) ? decoded : null
	} catch {
		return null
	}
}
